import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=0f81c773&scoped=true&"
import script from "./addForm.vue?vue&type=script&lang=js&"
export * from "./addForm.vue?vue&type=script&lang=js&"
import style0 from "./addForm.vue?vue&type=style&index=0&id=0f81c773&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81c773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f81c773')) {
      api.createRecord('0f81c773', component.options)
    } else {
      api.reload('0f81c773', component.options)
    }
    module.hot.accept("./addForm.vue?vue&type=template&id=0f81c773&scoped=true&", function () {
      api.rerender('0f81c773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/product-score-rules/form/components/addForm.vue"
export default component.exports